import AjaxService from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchExternalAccounts = ({ offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'accounts',
        params: {
            offset,
            limit
        }
    }, true)
    .then(response => ({
        items: response.data.accounts.map(item => {
            if (item.provider === 'google' && item.token_info?.scope?.indexOf('auth/drive') < 0) {
                return {
                    ...item,
                    provider: 'googleDeprecated'
                };
            }

            return item;
        })
    }))
    .catch(handleServerError);
}

export const createExternalAccount = ({ provider, token, code }, masterToken) => {
    return AjaxService({
        method: 'post',
        url: 'accounts',
        data: {
            provider,
            token,
            code
        }
    }, true, masterToken)
    .then(response => response.data);
}

export const removeExternalAccount = accountId => {
    return AjaxService({
        method: 'delete',
        url: `accounts/${accountId}`
    }, true)
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchExternalAccountsTeam = ({ offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'accounts',
        params: {
            offset,
            limit,
            team: true
        }
    })
    .then(response => ({
        items: response.data.accounts
    }))
    .catch(handleServerError);
}

export const createExternalAccountTeam = ({ provider, token, code }, teamToken) => {
    return AjaxService({
        method: 'post',
        url: 'accounts',
        data: {
            provider,
            token,
            code,
            team: true
        }
    }, false, teamToken)
    .then(response => response.data);
}

export const removeExternalAccountTeam = accountId => {
    return AjaxService({
        method: 'delete',
        url: `accounts/${accountId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const getAccountToken = (provider, useUser) => {
    return AjaxService({
        method: 'get',
        url: `accounts/${provider}/token`
    }, useUser)
    .then(response => response.data)
}
